export default "__VITE_ASSET__Df59K_lq__"